import React from 'react';
import Layout from '../components/Layout';
import TenantList from '../components/TenantAdmin/TenantList';
import useAutoTranslate from '../hooks/useAutoTranslate';
import {
  Card,
  CardHeader,
  Avatar,
  Icon
} from '@ui5/webcomponents-react';

const AdminTenants = () => {
  const { autoT } = useAutoTranslate();
  return (
    <Layout>
      <div>
        <Card style={{ marginBottom: '1.5rem' }}>
          <CardHeader
            titleText={autoT('Gestión de Tenants')}
            subtitleText={autoT('Administra los arrendatarios de la plataforma')}
            avatar={
              <Avatar
                style={{
                  backgroundColor: 'var(--sapAccentColor6)',
                  color: 'white'
                }}
              >
                <Icon name="customer" />
              </Avatar>
            }
          />
        </Card>
        <TenantList />
      </div>
    </Layout>
  );
};

export default AdminTenants;
